
<template>
  <div class="aibot-container"></div>
</template>
<script>
export default {
  data() {
    return {
      showChat:true
    }
  },
  mounted() {
    this.assistant = new AIAssistant({
      showBall: false,
      autoOpen: false,
      dom:this.$el,
      eventHandler:((e)=>{
        this.toggleAI()
      })
    })
    this.$register('$ai', this.assistant)
    this.$api.afterLogin(()=>{
      let uid = this.$store.getters['session/session'].zzl_id
      this.assistant.login(uid).then(()=>{
        this.assistant.setLocalFunctionCalling([{ name: 'routeMatch',           // 函数名称
            description: '根据用户意图，识别到用户需要打开某个系统、打开某个页面或者跳转页面，请调用此函数查询路径',        // 函数描述（用于 AI 理解）
            parameters: {                   // 参数定义（JSON Schema 格式）
              type: 'object',
              properties: {
                prompt: {
                  type: 'string',
                  description:'用户的需求'
                },
              },
              required: ['prompt']
            },
            handler: async (params) => {   // 函数执行器
              let result = await this.assistant.chat({
                  model_id:'deepseek-v3',
                  messages:[{
                    role:'system',content:`你是一个助手，根据用户需求匹配系统路由表，返回json格式{path:'/url完整路径'}即可。
                    当前用户权限：${this.$store.getters['session/session'].roles.map(v=>v.name).join(',')}
                    下面是系统已知的路由表:
                    合约系统 /core/cm/dashboard/dashboard
                    知识库 /core/knowledge
                    AI实验室 /core/ai/zzl/category
                    平台管理 /core/admin （只有管理员权限可以访问)
                    `
                  },{
                    role:'user',content:`用户的需求是:${params.prompt}`
                  }],
                  value_type:'json'
                })
              let message = '执行失败'
              if(result && result.path){
                this.RouteTo(result.path)
                message = '执行成功'
              }
              return { success: true, message };
            }}])  
      })
      
    })
    this.$bus.$on('toggle-ai',()=>{
      this.toggleAI()
    })
  },
  beforeDestroy(){
    // this.assistant.destroy();
    // 移除类名为ai-dialog的元素
    if (typeof window !== 'undefined') {
      const dialogs = document.querySelectorAll('.ai-dialog');
      dialogs.forEach(el => el.remove());
    }
  },
  methods:{
    toggleAI(){
      this.$store.commit('session/toggleAI')
    }
  }
  
}
</script>

<style lang="less" scoped>
.aibot-container {
  width:440px;
  height:100%;
  position: relative;
}

  

</style>